import { render, staticRenderFns } from "./VehicleList.vue?vue&type=template&id=18ead784&scoped=true"
import script from "./VehicleList.vue?vue&type=script&lang=js"
export * from "./VehicleList.vue?vue&type=script&lang=js"
import style0 from "./VehicleList.vue?vue&type=style&index=0&id=18ead784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ead784",
  null
  
)

export default component.exports